import { useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Briefcase, ExternalLink } from "lucide-react";

export default function MockEmploymentEmail() {
  const [searchParams] = useSearchParams();
  const verifierName = searchParams.get("verifierName") || "Verifier";
  const applicantName = searchParams.get("applicantName") || "Applicant";
  const program = searchParams.get("program") || "Program";
  const portalToken = searchParams.get("portalToken") || "";
  const portalUrl = `${window.location.origin}/employment-verify/${portalToken}`;

  return (
    <div className="min-h-screen bg-[#0a0e14] flex items-center justify-center p-4">
      <div className="max-w-xl w-full">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#FF9800]/10 border border-[#FF9800]/30 text-[#FF9800] text-xs font-medium">
            Mock Email Preview
          </div>
        </div>

        <div className="rounded-2xl border border-white/[0.06] bg-white/[0.02] overflow-hidden">
          <div className="bg-gradient-to-r from-[#FF6B35] to-[#FF9800]/80 px-6 py-5">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                <Briefcase className="w-4 h-4 text-white" />
              </div>
              <div>
                <h3 className="text-white font-semibold">University of St. Augustine for Health Sciences</h3>
                <p className="text-white/60 text-xs">Employment Verification Request</p>
              </div>
            </div>
          </div>

          <div className="p-6 space-y-4">
            <p className="text-slate-300 text-sm">
              Dear <span className="text-white font-medium">{verifierName}</span>,
            </p>
            <p className="text-slate-300 text-sm leading-relaxed">
              <span className="text-white font-medium">{applicantName}</span> has listed you as a verifier for their employment history as part of their application to the <span className="text-[#FF9800]">{program}</span> program at the University of St. Augustine for Health Sciences.
            </p>
            <p className="text-slate-300 text-sm leading-relaxed">
              Please take a moment to verify the period of employment and the position the applicant held in your organization or practice by clicking the button below.
            </p>

            <div className="pt-2">
              <Button
                onClick={() => window.open(portalUrl, "_blank")}
                className="bg-[#FF6B35] hover:bg-[#e55a25] text-white rounded-xl px-6 shadow-[0_0_15px_rgba(255,107,53,0.3)]"
                data-testid="emp-email-verify-btn"
              >
                Verify Employment
                <ExternalLink className="w-3.5 h-3.5 ml-2" />
              </Button>
            </div>

            <div className="pt-4 border-t border-white/[0.06] text-slate-500 text-xs leading-relaxed">
              <p>If you have any questions, please contact the Office of Admissions at admissions@usa.edu.</p>
              <p className="mt-2">This is an automated message. Please do not reply directly to this email.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
